module.exports = __webpack_public_path__ + "img/Knowit_graphic_logo.8eb10c83.png";